// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"kv-z","giftOrPromoSelector":"lv-z","disabled":"mv-z","subTitle":"nv-z","selectShipAddressMessage":"ov-z","changePayment":"pv-z"};